import { AddBusinessDetailsPrompt } from "@/components/AddBusinessDetailsPrompt";
import PageLoader from "@/components/ui/PageLoader";
import { Button } from "@/components/ui/button/button";
import Typography from "@/components/ui/typography";
import { useAuth } from "@/context/auth-context";
import useGetCreditCards from "@/features/credit-cards/useGetCreditCards";
import { Link, useLoaderData } from "@tanstack/react-router";
import { CircleHelp, XIcon } from "lucide-react";
import AddCreditCard from "../../../components/_module/home/creditCard";
import SelectDeposit from "../../../components/pages/deposit/selectDeposit";
import { getHelpCenterUrl } from "@/lib/utils";

const DepositPage = () => {
	const { user } = useAuth();
	const {
		user: { guest_business_details },
	} = useLoaderData({ from: "/main" });
	const { location_id } = useLoaderData({ from: "__root__" });
	const creditCardsQuery = useGetCreditCards({
		guestId: user.id,
		locationId: location_id,
	});

	if (guest_business_details.length === 0) {
		return (
			<AddBusinessDetailsPrompt>
				<Button className="w-full" asChild>
					<Link
						to="/main/setting/business-details/create"
						search={{ callback: "/main/deposit" }}
					>
						Add business details
					</Link>
				</Button>
			</AddBusinessDetailsPrompt>
		);
	}

	return (
		<PageLoader query={creditCardsQuery}>
			{(creditCards) => {
				const sortedByDefaultCardFirst = creditCards.slice().sort((a, b) => {
					if (a.default && !b.default) return -1;
					if (!a.default && b.default) return 1;
					return 0;
				});
				return (
					<div className="p-6 flex flex-col gap-4 w-full ">
						<Link
							to="/main/home"
							type="button"
							className="relative flex w-full"
						>
							<XIcon className="absolute right-0 -top-2" role="button" />
						</Link>
						<div className="flex flex-col items-center">
							<Typography variant={"h1"} className="text-center">
								Convert Credit <br /> to Cash
							</Typography>
						</div>
						{creditCards.length > 0 ? (
							<SelectDeposit creditCards={sortedByDefaultCardFirst} />
						) : (
							<AddCreditCard setPageStep={() => {}} />
						)}
						<a
							href={getHelpCenterUrl()}
							target="_blank"
							rel="noopener noreferrer"
							className="flex items-center justify-center gap-2"
						>
							<CircleHelp className="w-5 h-5 text-textDark" />
							<span className="text-textDark">Need Help?</span>{" "}
							<span className="text-textDark font-semibold">
								Contact Support
							</span>
						</a>
					</div>
				);
			}}
		</PageLoader>
	);
};

export default DepositPage;
